const formsAnimation = {
  init() {
    if ($(".js-form-animated").length) {
      var formInputs = $(".form-animated input, .form-animated textarea");
      formInputs.on({
        blur: function () {
          if ($(this).val()) {
            $(this).addClass("used");
          } else {
            $(this).removeClass("used");
          }
        },
        focus: function () {
          $(this).addClass("used");
        },
        click: function () {
          $(this).addClass("used");
        },
      });
    }
  },
};

export default formsAnimation;
